/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectTaskBudgetCostCommand } from '../../models/update-project-task-budget-cost-command';
import { UpdateProjectTaskBudgetCostCommandResult } from '../../models/update-project-task-budget-cost-command-result';

export interface ApiTaskBudgetCostUpdateTaskBudgetCostPost$Plain$Params {
      body?: UpdateProjectTaskBudgetCostCommand
}

export function apiTaskBudgetCostUpdateTaskBudgetCostPost$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskBudgetCostUpdateTaskBudgetCostPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskBudgetCostCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskBudgetCostUpdateTaskBudgetCostPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectTaskBudgetCostCommandResult>;
    })
  );
}

apiTaskBudgetCostUpdateTaskBudgetCostPost$Plain.PATH = '/api/TaskBudgetCost/UpdateTaskBudgetCost';
